export const createBoardUrl = (
	boardId: string,
	locationKey: string,
	accountId?: string,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	isNextGenBoard: boolean,
) => {
	if (isNextGenBoard) {
		return `/jira/software/projects/${locationKey}/boards/${boardId}`;
	}

	if (accountId != null) {
		return `/jira/people/${accountId}/boards/${boardId}`;
	}

	if (locationKey) {
		return `/jira/software/c/projects/${locationKey}/boards/${boardId}`;
	}

	return `/secure/RapidBoard.jspa?rapidView=${boardId}&useStoredSettings=true&locationless=true`;
};
